import { get } from "db/api";

export const searchPlans = async () => {
  try {
    const response = await get("/search-plans");
    const data = await response.json();

    if (!response.ok) {
      console.error("Error en la función:", data.error);
      return;
    }

    return data;
  } catch (error) {
    console.error("Error inesperado:", error.message);
  }
};
